export default "__VITE_ASSET__c6101e5e__"